import axios from 'axios'
import { getAppCheckToken } from './firebase'

const API_BASE_URL = import.meta.env.VITE_API_URL || '/api/portal'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Request interceptor to add auth token + App Check token
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('portal_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    try {
      const appCheckToken = await getAppCheckToken()
      if (appCheckToken) {
        config.headers['X-Firebase-AppCheck'] = appCheckToken
      }
    } catch (error) {
      // Don't block requests if App Check fails
    }

    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Don't redirect on auth endpoints - let the login page handle those errors
    const isAuthEndpoint = error.config?.url?.includes('/auth/') ||
                          error.config?.url?.includes('/login') ||
                          error.config?.url?.includes('/password-reset')

    if (error.response?.status === 401 && !isAuthEndpoint) {
      // Token expired or invalid for protected routes, redirect to login
      localStorage.removeItem('portal_token')
      localStorage.removeItem('portal_client')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default api
